import React, { useEffect, useLayoutEffect } from 'react'
import { useAuth } from '@/processes/authorisePassport'

export const RedirectUnAuthUser = ({ children, firstRenderSuccess = (user) => {} }) => {
	const { handleGetCurrentUser, authData } = useAuth()

	useLayoutEffect(() => {
		let body = {
			onSuccess: (user) => {
				firstRenderSuccess(user)
			},
			onError: () => {},
		}

		if (!authData.data) {
			handleGetCurrentUser(body)
		}
	}, [])

	useEffect(() => {
		const getUser = () => {
			handleGetCurrentUser({
				onSuccess: (user) => {},
				onError: () => {},
			})
		}
		const timer = setInterval(getUser, 120000)
		return () => clearInterval(timer)
	}, [handleGetCurrentUser])

	return <>{children}</>
}
